import Nav from "../../components/Nav";
import { useState } from "react";
import { FaCrown } from "react-icons/fa"; // Importing the crown icon
import { Link } from "react-router-dom";

export default function ProductsPage() {
  const products = [
    {
      id: 1,
      name: "Printable Planner",
      price: "$9.99",
      description: "Get organized with this beautifully designed printable book planner for all your scheduling needs.",
      imagePath: "/images/807cb630-f148-4ed3-8d89-d4dbf753f3a0-planner.jpg",
      crown: false
    },
    {
      id: 2,
      name: "Premium Photoshop Templates",
      price: "$19.99",
      description: "High-quality Photoshop templates for creative projects.",
      imagePath: "/images/8518956e-74c9-4fb2-95f2-ced8a43c8256-mount.jpg",
      crown: false
    },
    {
      id: 3,
      name: "HTML & CSS - For Beginners",
      price: "$39.99",
      description: "Master the basics of web development with this beginner-friendly HTML & CSS course.",
      imagePath: "/images/fadb4f67-b64d-41bf-8843-da56482b792d-webdev.jpg",
      crown: false
    },
    {
      id: 4,
      name: "Advanced 3D Modeling Course",
      price: "$59.99",
      description: "Take your 3D modeling skills to the next level with this comprehensive course.",
      imagePath: "/images/3d.jpg",
      crown: true // Manually added crown to this product
    },
    {
      id: 5,
      name: "Pro Photography Editing Tools",
      price: "$49.99",
      description: "Enhance your photos with advanced editing tools and filters.",
      imagePath: "/images/photoeditor.png",
      crown: false
    },
    {
      id: 6,
      name: "Introduction to UX Design",
      price: "$39.99",
      description: "Start your journey in UX design with this foundational course.",
      imagePath: "/images/Diseño-UX-UI.jpg",
      crown: false
    },
    {
      id: 7,
      name: "Premium Website Templates",
      price: "$24.99",
      description: "High-quality website templates for all types of businesses.",
      imagePath: "/images/eflyer.jpg",
      crown: false
    },
    {
      id: 8,
      name: "E-commerce Setup Guide",
      price: "$79.99",
      description: "Comprehensive guide to setting up and running an e-commerce store.",
      imagePath: "/images/1675349943774.jpeg",
      crown: true
    },
    {
      id: 9,
      name: "Digital Marketing Masterclass",
      price: "$99.99",
      description: "Learn advanced digital marketing strategies to grow your business.",
      imagePath: "/images/hq720.jpg",
      crown: false
    },
    {
      id: 10,
      name: "Illustrator Brush Pack",
      price: "$14.99",
      description: "A set of custom brushes for Adobe Illustrator to elevate your designs.",
      imagePath: "/images/brushes.avif",
      crown: false
    },
    {
      id: 11,
      name: "Complete Guide to WordPress",
      price: "$59.99",
      description: "Master WordPress with this comprehensive course and guide.",
      imagePath: "/images/make-a-wordpress-website.png",
      crown: false
    },
    {
      id: 12,
      name: "Online Business Starter Kit",
      price: "$69.99",
      description: "Everything you need to start your own online business.",
      imagePath: "/images/maxresdefault (1).jpg",
      crown: true
    },
  ];

  const [popupVisible, setPopupVisible] = useState(false);

  const handlePurchaseClick = (productId) => {
    const product = products.find(p => p.id === productId);
    if (product.crown) {
      setPopupVisible(true); // Trigger the popup for crown products
    } else {
      // Redirect to the purchase page for non-crown products
      window.location.href = `/products/purchase/${productId}`;
    }
  };

  const closePopup = () => {
    setPopupVisible(false);
  };

  return (
    <div>
      {/* Nav outside main content */}
      <Nav />

      {/* Main content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <header className="text-center mb-8">
          <h1 className="text-4xl font-extrabold text-gray-900">
            Explore Our Products
          </h1>
          <p className="mt-4 text-lg text-gray-600">
            Discover a curated selection of high-quality resources, courses, and tools designed to inspire and empower your creativity.
          </p>
        </header>

        {/* Product Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {products.map((product) => (
            <div
              key={product.id}
              className={`flex overflow-hidden flex-col rounded-[25px] shadow-lg hover:shadow-xl transition-shadow duration-300 border-none ${
                product.crown ? "border-4 border-yellow-500" : ""
              }`} // Add border if crown is true
            >
              {/* Card Content */}
              <div className="relative w-full h-auto aspect-video">
                <img
                  src={product.imagePath}
                  alt={product.name}
                  className="w-full h-auto object-cover"
                />
                {/* Display crown icon if product has crown */}
                {product.crown && (
                  <div className="absolute top-2 right-2 text-yellow-500 text-3xl">
                    <FaCrown /> {/* Using React Icon for crown */}
                  </div>
                )}
              </div>
              <div className="flex flex-col space-y-1.5 p-6">
                <h3 className="text-2xl font-semibold leading-none tracking-tight">{product.name}</h3>
                <p className="text-sm text-muted-foreground">{product.price}</p>
              </div>
              <div className="flex-grow p-6 pt-0">
                <p className="line-clamp-4">{product.description}</p>
              </div>
              <div className="flex items-center p-6 pt-0">
                <button
                  className={`w-full py-3 px-4 text-lg rounded-lg ${product.crown ? 'bg-gray-400 text-white cursor-pointer' : 'bg-gradient-to-r from-orange-400 via-red-500 to-pink-500 text-white hover:scale-105 hover:from-orange-500 hover:to-pink-600 focus:ring-2 focus:ring-orange-500" text-white hover:bg-gradient-to-r from-orange-400 via-red-500 to-pink-500 text-white hover:scale-105 hover:from-orange-500 hover:to-pink-600 focus:ring-2 focus:ring-orange-500'}`}
                  onClick={() => handlePurchaseClick(product.id)}
                >
                  {product.crown ? 'Exclusive - Upgrade to Nuvia Pro' : 'Purchase'}
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Popup */}
        {popupVisible && (
  <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center z-50">
    <div className="bg-white p-6 rounded-lg shadow-lg max-w-sm w-full text-center">
      <h2 className="text-lg font-semibold">Access Restricted</h2>
      <p className="mt-2 text-sm">
        You need a Nuvia Pro membership to access this product. 
        <span className="text-sm font-bold bg-gradient-to-r from-pink-500 to-orange-500 bg-clip-text text-transparent"><Link to="/go-pro"> Get Nuvia Pro Now!</Link></span>
      </p>
      <div className="mt-4">
        <button className="w-full py-3 px-4 bg-gradient-to-r from-orange-400 via-red-500 to-pink-500 text-white text-lg rounded-lg hover:bg-gradient-to-r from-orange-400 via-red-500 to-pink-500" onClick={closePopup}>Close</button>
      </div>
    </div>
  </div>
)}
      </div>
    </div>
  );
}